/** @jsxImportSource theme-ui */
import { Button } from "theme-ui";
import Image from "next/image";
import { useRouter } from "next/router";

import { Sprite } from "components/Common/Sprite";

import { validatePermissions } from "utils/UserHelpers";
import Link from "next/link";
import { useRole } from "hooks/UseRole";
import { OrganizationRole, Role } from "@prisma/client";

export const USER_LINKS = [];

export const SIDEBAR_LINKS = [
  {
    text: "Reports",
    link: "/dashboard",
    icon: "reports-icon",
    permission: [Role.USER, Role.REVIEWER],
    type: "user",
  },
  {
    text: "Credits",
    link: "/dashboard/credits",
    icon: "credits-icon",
    permission: [OrganizationRole.ADMIN],
    type: "organization",
  },
  {
    text: "Cases",
    link: "/admin",
    icon: "reports-icon",
    permission: [Role.ADMIN],
    type: "user",
  },
  {
    text: "Users",
    link: "/admin/users",
    icon: "users",
    permission: [Role.ADMIN],
    type: "user",
  },
  {
    text: "Organizations",
    link: "/admin/organizations",
    icon: "users",
    permission: [Role.ADMIN],
    type: "user",
  },
  {
    text: "Organization",
    link: "/dashboard/users",
    icon: "users",
    permission: [OrganizationRole.ADMIN],
    type: "organization",
  },
  {
    text: "Cards",
    link: "/dashboard/billing",
    icon: "cards-icon",
    permission: [OrganizationRole.ADMIN],
    type: "organization",
  },
  {
    text: "Invoices",
    link: "/dashboard/invoices",
    icon: "invoices-icon",
    permission: [OrganizationRole.ADMIN],
    type: "organization",
  },
  {
    text: "Settings",
    link: "/dashboard/settings",
    icon: "settings-icon",
    permission: [],
  },
];

const DashboardSidebar = () => {
  const currentRole = useRole();
  const router = useRouter();

  if (!currentRole) {
    return null;
  }

  return (
    <aside
      sx={{
        display: ["none", null, "block"],
        pr: 5,
        flex: "0 auto",
      }}
    >
      <ul
        sx={{
          p: 0,
          m: 0,
          listStyle: "none",
          li: {
            mb: 5,
          },
        }}
      >
        {SIDEBAR_LINKS.map(({ text, icon, permission, link, type }) => {
          if (validatePermissions(currentRole, permission, type)) {
            return (
              <li key={text}>
                <Link href={link} passHref={true}>
                  <a
                    className={link === router.asPath && "active"}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      variant: "buttons.dashboardSidebar",
                      textDecoration: "none",
                    }}
                  >
                    <span
                      sx={{
                        display: "block",
                        img: {
                          fill: "red",
                        },
                      }}
                    >
                      <Sprite
                        icon={icon}
                        sx={{
                          width: "27px",
                          height: "27px",
                        }}
                      />
                    </span>
                    {text}
                  </a>
                </Link>
              </li>
            );
          } else {
            return null;
          }
        })}
        <li>
          <Button
            variant="dashboardSidebar"
            sx={{
              color: "themedDarkBlue",
            }}
            onClick={() => router.push("/api/auth/logout")}
          >
            <span
              sx={{
                ml: "5px",
                pr: "5px",
                img: {
                  fill: "red",
                },
              }}
            >
              <Image
                src="/img/icons/logout-icon.svg"
                alt=""
                width={17}
                height={17}
                layout="fixed"
              />
            </span>
            Logout
          </Button>
        </li>
      </ul>
    </aside>
  );
};

export default DashboardSidebar;
